import { render } from "./StateList.vue?vue&type=template&id=ff2500da"
import script from "./StateList.vue?vue&type=script&lang=js"
export * from "./StateList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__